import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("opturna_cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem("opturna_cookie_consent", "accepted");
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("opturna_cookie_consent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] p-4" data-testid="cookie-banner">
      <div className="max-w-3xl mx-auto bg-white rounded-xl border border-[#e4e8ee] shadow-lg p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1">
          <p className="text-sm font-medium text-[#1e3a5f] mb-1">We use cookies</p>
          <p className="text-xs text-[#5a6577] leading-relaxed">
            Opturna uses cookies to improve functionality, remember your preferences, and analyze platform usage.
            By clicking "Accept," you consent to our use of cookies. Read our{" "}
            <Link to="/privacy" className="text-[#4a9eff] hover:underline">Privacy Policy</Link> and{" "}
            <Link to="/terms" className="text-[#4a9eff] hover:underline">Terms of Service</Link> for more details.
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={handleDecline}
            className="px-4 py-2 rounded-lg border border-[#e4e8ee] text-sm text-[#5a6577] hover:bg-[#f5f7fa] transition-colors"
            data-testid="cookie-decline-btn"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-2 rounded-lg bg-[#1e3a5f] text-white text-sm font-medium hover:bg-[#2d5a8e] transition-colors"
            data-testid="cookie-accept-btn"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
